import { render, staticRenderFns } from "./PmRight-mf.vue?vue&type=template&id=44b654dc&scoped=true&"
import script from "./PmRight-mf.vue?vue&type=script&lang=js&"
export * from "./PmRight-mf.vue?vue&type=script&lang=js&"
import style0 from "./PmRight-mf.vue?vue&type=style&index=0&id=44b654dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b654dc",
  null
  
)

export default component.exports